import React from 'react'
import AgentSignupComp from '../../components/auth/AgentSignupComp'

const AgentSignup = () => {
  return (
    <div>
        <AgentSignupComp />
    </div>
  )
}

export default AgentSignup